import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X as XIcon } from 'lucide-react';
import styles from './Modal.module.css';
import ZINDEXES from '@/constants/zIndexes';
import Card from '@/components/Card/Card';
import Button from '@/components/Button/Button';

const Modal = ({
    isOpen,
    width = '400px',
    onClose,
    children,
    title,
    animation = 'slide', //slide - zoom - fade
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (isOpen && !mounted) {
            setMounted(true);
            setIsClosing(false);
        }
    }, [isOpen, mounted]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setMounted(false);
            onClose();
        }, 200);
    };

    useEffect(() => {
        if (!isOpen && mounted) {
            handleClose();
        }
    }, [isOpen, mounted]);

    useEffect(() => {
        if (!mounted) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [mounted]);

    if (!mounted) return null;

    return createPortal(
        <div
            className={`${styles.overlay} ${isClosing ? styles.overlayOut : ''}`}
            style={{ zIndex: ZINDEXES.MODAL }}
            onClick={handleClose}
        >
            <Card
                className={`${styles.content} ${isClosing ? styles[`${animation}Out`] : styles[`${animation}In`]}`}
                style={{ width: window.innerWidth > 760 && width }}
                onClick={(e) => e.stopPropagation()}
            >
                <Card.Header>
                    <div className="flex w-100 items-center justify-between mb-4">
                        <div className={styles.title}>{title}</div>

                        <Button
                            icon={XIcon}
                            iconSize={12}
                            appearance="flat"
                            variant="neutral"
                            size="xs"
                            onClick={handleClose}
                        />
                    </div>
                </Card.Header>
                {children}
            </Card>
        </div>,
        document.getElementById('modal-root')
    );
};

export default Modal;
